import { Link } from 'react-router'
import PageShell from '../components/PageShell'
import { GUIDE_CATEGORIES, GUIDES } from '../content/guides'
import { STATES } from '../content/states'

export default function GuidesPage() {
  return (
    <PageShell title="Government Contracting Guides" intro="Plain-language guidance for contractors learning how public procurement works, how to prepare a compliant response, and which requirements to verify before bidding.">
      {GUIDE_CATEGORIES.map((category) => (
        <section key={category} className="mb-12">
          <h2 className="text-xl font-semibold text-white mb-5">{category}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {GUIDES.filter((guide) => guide.category === category).map((guide) => (
              <Link key={guide.slug} to={`/guides/${guide.slug}`} className="block bg-white/[0.03] border border-white/[0.08] rounded-xl p-6 hover:border-[#06b6d4]/50 transition-colors">
                <h3 className="text-lg font-semibold text-white mb-2">{guide.shortTitle}</h3>
                <p className="text-sm text-[#9ca3af] leading-[1.65]">{guide.description}</p>
                <span className="inline-block mt-4 text-sm text-[#06b6d4]">Read the guide →</span>
              </Link>
            ))}
          </div>
        </section>
      ))}
      <section className="mb-12">
        <h2 className="text-xl font-semibold text-white mb-3">Ready to look at real opportunities?</h2>
        <p className="text-[15px] text-[#9ca3af] leading-[1.7] mb-4">
          <a href="https://app.procuralerts.com/bids" className="text-[#06b6d4] hover:text-[#22d3ee]">Browse Live Bids</a>{' '}
          to see the current public inventory — no account required — or visit the{' '}
          <Link to="/government-bids" className="text-[#06b6d4] hover:text-[#22d3ee]">New England government bids hub</Link>{' '}
          to see what ProcurAlerts monitors in each state:
        </p>
        <div className="flex flex-wrap gap-2">
          {STATES.map((state) => (
            <Link
              key={state.slug}
              to={`/government-bids/${state.slug}`}
              className="border border-white/[0.1] rounded-lg px-3 py-2 text-sm text-[#9ca3af] hover:text-[#06b6d4] hover:border-[#06b6d4]/40"
            >
              {state.name}
            </Link>
          ))}
        </div>
      </section>
      <aside className="border-l-2 border-[#06b6d4] bg-[#06b6d4]/[0.05] p-5 text-sm text-[#9ca3af] leading-[1.7]">
        These guides are educational, not legal, accounting, wage, or eligibility advice. Requirements vary by agency, jurisdiction, funding source, and solicitation. Always verify the current official documents with the issuing agency.
      </aside>
    </PageShell>
  )
}
